<template>
  <div class="person-user-menu" :class="[`is-${level}`, `is-${gender}`, { 'is-fetching': _get(PersonDetails, 'fetching') }]">
    <div class="person-user-menu__gender-icon">
      <i :title="$t(`label.${gender}`)" :class="personSymbol"></i>
    </div>
    <div class="top">
      <div class="image-wrap">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
          <filter id="blur">
              <feGaussianBlur stdDeviation="10" />
          </filter>
        </svg>
        <div class="background-mask">
          <div class="full-picture blur" :style="pictureBackgroundImage"></div>
        </div>
        <div class="image-circle">
          <div class="image" :style="pictureBackgroundImage"></div>
          <i :class="participantIconClass"></i>
        </div>
      </div>
      <div v-show="_get(PersonDetails, 'fetching')">
        <span class="text-dummy-loader"></span>
        <span class="text-dummy-loader is-slim-wide"></span>
      </div>
      <div v-show="!_get(PersonDetails, 'fetching')">
          <p class="name">
            <span>{{ _get(PersonDetails, 'data.full_name') }}</span>
          </p>
          <p class="email">
            <span v-if="professinalRole">{{ professinalRole.name }}</span>
          </p>
      </div>
    </div>
    <p class="ui-element horizontal-divider">
      <span>{{ $t(label) }}</span>
    </p>
  </div>
</template>

<script>
import { get, first } from 'lodash';
import PersonProfileCard from './person-profile-card';

export default {
  name: 'professional-profile-card',
  mixins: [PersonProfileCard],
  computed: {
    professinalRole() {
      const roles = get(this.PersonDetails, 'data.Roles', []);
      const primary = find(roles, role => get(role, 'PersonRole.primary_role'));
      return primary || first(roles);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/card/professional-profile-card.vue